import { useEffect } from 'react'
import Shepherd from 'shepherd.js'
import 'shepherd.js/dist/css/shepherd.css'
import './style.css'
import { useDispatch } from 'react-redux'
import { setPolicyTileCardTour, setRiskScoreTourPopup } from 'src/actions/index'
import { POPUP_STEPS } from 'src/utils/constants/TourConstants'

export default function RiskScorePopUpTour() {
  const dispatch = useDispatch()

  useEffect(() => {
    const riskScorePopUpTour = new Shepherd.Tour({
      useModalOverlay: true,
      exitOnEsc: false,
      defaultStepOptions: {
        scrollTo: true,
      },
    })

    riskScorePopUpTour?.addStep({
      id: POPUP_STEPS?.STEP_1,
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      attachTo: {
        element: '#riskScorePopUp',
        on: 'bottom',
      },
      buttons: [
        {
          text: 'Next',
          action: () => {
            document.querySelector('#yourPolicies')?.click()
            riskScorePopUpTour?.complete()
          },
          classes: 'nextButton',
        },
      ],
    })

    riskScorePopUpTour?.start()

    const handleTourComplete = () => {
      dispatch(setRiskScoreTourPopup(false))
      dispatch(setPolicyTileCardTour(true))
    }
    riskScorePopUpTour?.on('complete', handleTourComplete)

    return () => {}
  }, [dispatch])

  return null
}
